import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

import { DateCell, CurrencyCell, IdentifierCell, DownloadCell, TransactionTypeCell } from './cells';

import { dateTime, transactionType, orderNumbers, fulfillmentPlanIds, costTotal, creditTotal, endingBalance, invoice } from './constants';

export const walletBalanceHistoryColumns = [
  {
    Header: <FormattedMessage {...messages.dateHeader} />,
    accessor: dateTime,
    Cell: DateCell,
  },
  {
    Header: <FormattedMessage {...messages.orderHeader} />,
    accessor: orderNumbers,
    Cell: IdentifierCell,
  },
  {
    Header: <FormattedMessage {...messages.shipmentHeader} />,
    accessor: fulfillmentPlanIds,
    Cell: IdentifierCell,
  },
  {
    Header: <FormattedMessage {...messages.type} />,
    accessor: transactionType,
    Cell: TransactionTypeCell,
    width: 120,
  },
  {
    Header: <FormattedMessage {...messages.creditHeader} />,
    accessor: creditTotal,
    Cell: CurrencyCell,
    width: 120,
  },
  {
    Header: <FormattedMessage {...messages.costHeader} />,
    accessor: costTotal,
    Cell: CurrencyCell,
    width: 120,
  },
  {
    Header: <FormattedMessage {...messages.balance} />,
    accessor: endingBalance,
    Cell: CurrencyCell,
    width: 120,
  },
  {
    Header: <FormattedMessage {...messages.download} />,
    accessor: invoice,
    Cell: DownloadCell,
    width: 120,
  },
];
